module.exports = __webpack_public_path__ + "static/media/button_trash.462f1b1b.svg";